export default __webpack_public_path__ + "static/media/indexRatePlusStaticMargin.85701878.svg";